import { render, staticRenderFns } from "./Notificationsettings.vue?vue&type=template&id=00cea680&"
import script from "./Notificationsettings.vue?vue&type=script&lang=js&"
export * from "./Notificationsettings.vue?vue&type=script&lang=js&"
import style0 from "./Notificationsettings.vue?vue&type=style&index=0&id=00cea680&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports